import { render, staticRenderFns } from "./transforvideo.vue?vue&type=template&id=4f86e804&scoped=true&"
import script from "./transforvideo.vue?vue&type=script&lang=js&"
export * from "./transforvideo.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./transforvideo.vue?vue&type=style&index=0&id=4f86e804&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4f86e804",
  null
  ,true
)

export default component.exports